import { Box, Container } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles';
import CardOpcoes from '../utils/cardOpcoes';
import HeaderSession from '../utils/headerSession';
import RegisterAccess from '../utils/registerAccess';

const useStyles = makeStyles((theme) => ({

    containerCardesService: {
        padding: '2rem',
        display: 'flex',
        flexWrap: 'wrap',
        //  flexDirection: 'wrap',
        /* ALINHAR OS ITENS NA HORIZONTAL E NA VERTIVACL */
        justifyContent: 'center',
        alignItems: 'center',
        /* AFASTAR UM ITEM DO OUTRO */
        gap: '1rem',
    }

}))

export default function ControleQualidade() {
    const classes = useStyles()
    return (
        <Container style={{ minHeight: '70vh', maxWidth: 800 }}>
            <RegisterAccess page={'controlo de qualidade'} />
            <HeaderSession title='CONTROLO DE QUALIDADE' />

            <Box className={classes.containerCardesService}>
            <CardOpcoes nomeService={'Solicitação de Análise Laboratorial'} link={'/controle-de-qualidade/formulario-de-solicitacao-de-analise-laboratorial'} />
            <CardOpcoes nomeService={'Formulário de Recolha de Amostras'} link={'/controle-de-qualidade/formulario-de-recolha-de-amostras'} />
            </Box>
        </Container>

    )
}
